import { Tooltip } from '@/components/basicComponents/tooltip';
import DropdownActions from '@/components/table/dropdownActions';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { IItems } from '@/components/table/types';
import { getUTCDate, isValidDate } from '@/shared/utils/date';
import { ROLE } from '@trace-8/trace8-schema';
import { format } from 'date-fns';
import styled from 'styled-components';
import { firmTableColumns } from '../../constants';
import { IUser } from '../../types';
import { formatUserPhoneNumber } from '../tableBody';

interface MobileTableProps {
  firmTableTableData: IUser[];
  flashUpdatingRow: string;
  actionsByStatus: (row: IUser) => IItems[];
}

const MobileTable = ({ firmTableTableData, flashUpdatingRow, actionsByStatus }: MobileTableProps) => {
  const TableRow = ({ el }: { el: IUser }) => {
    return (
      <MobileTableRowWrap key={el.id} loading={flashUpdatingRow === el.id ? 1 : 0}>
        <MobileRow>
          <MobileRowTitle>{firmTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue>{el.email}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{firmTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>
            {el.lastLogin && isValidDate(new Date(el.lastLogin)) && (
              <Tooltip title={`${getUTCDate(new Date(el.lastLogin))} ${format(new Date(el.lastLogin), 'h:mm a')}`}>
                {getUTCDate(new Date(el.lastLogin))}
              </Tooltip>
            )}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{firmTableColumns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.firstName}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{firmTableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.lastName}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{firmTableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>{formatUserPhoneNumber(el?.mobilePhoneNumber?.countryCode, el?.mobilePhoneNumber?.number)}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{firmTableColumns[5].title}</MobileRowTitle>
          <MobileRowValue>
            {el?.roles?.length > 1 ? (
              <Tooltip
                title={el.roles
                  .map((role) => ROLE[role])
                  .toString()
                  .replace(/,/g, ', ')}
                maxContentWidth={250}
              >
                Multiple ({el.roles.length})
              </Tooltip>
            ) : (
              el?.roles && ROLE[el.roles[0]]
            )}
          </MobileRowValue>
        </MobileRow>

        {!!actionsByStatus(el)?.length && (
          <DropdownActionsWrapper>
            <DropdownActions isMobile items={actionsByStatus(el)} isListCenter />
          </DropdownActionsWrapper>
        )}
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {firmTableTableData.length ? (
        firmTableTableData.map((el: any, index: number) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const DropdownActionsWrapper = styled.div`
  margin: 0 auto;
`;
